/* ===== FB Arama Akilli Eslesme (fb-search-exact v3) — 2026-07-11 =====
   KOK NEDEN: Shopify tam arama sayfasi 'typo tolerance' (fuzzy) uygular;
   4+ harfli kelimelerde 1 harf hata payiyla TUM alanlarda eslesme yapar
   -> alakasiz sonuclar (orn. q=tira -> 41 sonuc). Ayrica tam arama,
   predictive'in aksine KISMI kelimeyi (orn. 'ti') anlamaz.
   COZUM (v3 — modal ile ayni davranis):
   - Son kelimeye otomatik '*' eklenir -> Shopify PREFIX modu: 'ti' -> ti*
     Tira/Tirint/Titok bulur (fuzzy YOK, wildcard'da typo tolerance yok).
   - Onceki kelimeler tirnaklanir -> birebir eslesir, fuzzy kapanir.
     Ornek: 'dantel elbise' -> "dantel" elbise* ; 'tira' -> tira*
   - Yazarken cikan onerilere (predictive fetch) DOKUNMAZ.
   - Ozel sorgular (':', mevcut '*', mevcut tirnak, OR/AND) oldugu gibi kalir.
   - Listener'lar WINDOW capture'da: temanin document-delegation
     handler'larindan ONCE calisir (header Enter -> window.location dahil).
   - Eski tirnaksiz/duz linkler acilista BIR kez donusturulur (fb_fuzzy haric).
   - 0 sonuc guvenlik agi: sections/search-header.liquid fb_fuzzy donusuyle
     birlikte calisir (tirnak+yildiz sokulur, esnek arama denenir).
   - Gorsel temizlik: kutu + vitrin basligi (.fps-search-term) tirnak ve
     yildizsiz gosterilir (search.terms HTML-escape'li &quot; gelebilir). */
(function () {
  'use strict';

  var GUARD = /[":*]|\bOR\b|\bAND\b/;

  function fbTransform(raw) {
    var q = (raw || '').trim();
    if (!q || GUARD.test(q)) return raw;
    var words = q.split(/\s+/);
    var last = words.pop();
    var out = [];
    for (var i = 0; i < words.length; i++) out.push('"' + words[i] + '"');
    out.push(last + '*');
    return out.join(' ');
  }

  function fbStripMarkers(v) {
    return (v || '').replace(/&quot;/g, '').replace(/["*]/g, '').replace(/\s+/g, ' ').trim();
  }

  /* 0) Duz gelen /search linkleri (eski link, elle URL, arama motoru):
        acilista BIR kez akilli formata donustur. */
  (function fbUpgradeLanding() {
    try {
      if (window.location.pathname.indexOf('/search') === -1) return;
      var u = new URL(window.location.href);
      var q = u.searchParams.get('q');
      if (!q || !q.trim()) return;
      if (u.searchParams.get('fb_fuzzy') === '1') return; /* guvenlik agi sayfasi — dokunma */
      if (GUARD.test(q)) return; /* zaten donusturulmus veya ozel sorgu */
      u.searchParams.set('q', fbTransform(q));
      window.location.replace(u.pathname + u.search);
    } catch (err) {}
  })();

  /* 1) Arama sayfasi formu (native submit) */
  window.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (input && input.value) input.value = fbTransform(input.value);
    } catch (err) {}
  }, true);

  /* 2) Header aramasi: Enter -> tema window.location ile gider (submit event yok). */
  window.addEventListener('keydown', function (e) {
    try {
      if (e.key !== 'Enter') return;
      var el = e.target;
      if (!el || el.tagName !== 'INPUT') return;
      if (!el.closest || !el.closest('predictive-search-component')) return;
      if (el.value) el.value = fbTransform(el.value);
    } catch (err) {}
  }, true);

  /* 3) /search?q= linkleri (oneri / tum sonuclar linkleri) */
  window.addEventListener('click', function (e) {
    try {
      var t = e.target;
      var a = t && t.closest ? t.closest('a[href*="/search?"]') : null;
      if (!a) return;
      var u = new URL(a.getAttribute('href'), window.location.origin);
      if (u.origin !== window.location.origin) return;
      if (!/\/search$/.test(u.pathname)) return;
      var q = u.searchParams.get('q');
      if (!q || GUARD.test(q)) return;
      u.searchParams.set('q', fbTransform(q));
      a.setAttribute('href', u.pathname + u.search);
    } catch (err) {}
  }, true);

  /* 4) Gorsel temizlik: kutu + vitrin arama basligi (.fps-search-term).
        Dekoratif kivrik tirnaklar (“ ”) KORUNUR; duz tirnak, &quot; ve * kaldirilir. */
  function fbCleanDisplay() {
    try {
      if (window.location.pathname.indexOf('/search') === -1) return;
      var inputs = document.querySelectorAll('input[name="q"]');
      for (var i = 0; i < inputs.length; i++) {
        var v = inputs[i].value;
        if (v && (v.indexOf('"') !== -1 || v.indexOf('&quot;') !== -1 || v.indexOf('*') !== -1)) {
          inputs[i].value = fbStripMarkers(v);
        }
      }
      var terms = document.querySelectorAll('.fps-search-term');
      for (var j = 0; j < terms.length; j++) {
        var tx = terms[j].textContent;
        if (tx && (tx.indexOf('"') !== -1 || tx.indexOf('*') !== -1)) {
          terms[j].textContent = tx.replace(/["*]/g, '');
        }
      }
    } catch (err) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fbCleanDisplay);
  } else {
    fbCleanDisplay();
  }
})();
